<template>
  <div>
    <vx-card class="relative">
      <img
        src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/network-plus/02666920475176290222113/graphic.png"
        alt="Logo"
        draggable="false"
      />

      <!-- SWITCH ONE PORTS -->
      <span class="port" id="port-1" style="bottom: 49%; left: 9rem; width: 3rem; height: 2rem" @click="selectPort(1, 0)" />
      <span class="port" id="port-2" style="bottom: 49%; left: 12.5rem; width: 3rem; height: 2rem" @click="selectPort(1, 1)" />
      <span class="port" id="port-3" style="bottom: 49%; left: 16.2rem; width: 3rem; height: 2rem" @click="selectPort(1, 2)" />
      <span class="port" id="port-4" style="bottom: 49%; left: 19.7rem; width: 3rem; height: 2rem" @click="selectPort(1, 3)" />
      <span class="port" id="port-5" style="bottom: 49%; left: 23.3rem; width: 3rem; height: 2rem" @click="selectPort(1, 4)" />
      <span class="port" id="port-6" style="bottom: 49%; left: 26.85rem; width: 3rem; height: 2rem" @click="selectPort(1, 5)" />
      <span class="port" id="port-7" style="bottom: 49%; left: 30.45rem; width: 3rem; height: 2rem" @click="selectPort(1, 6)" />
      <span class="port" id="port-8" style="bottom: 49%; left: 33.9rem; width: 3rem; height: 2rem" @click="selectPort(1, 7)" />

      <!-- SWITCH THREE PORTS -->
      <span class="port" id="port-9" style="bottom: 28.8%; left: 48.3rem; width: 3rem; height: 2rem" @click="selectPort(3, 8)" />
      <span class="port" id="port-10" style="bottom: 28.8%; left: 51.9rem; width: 3rem; height: 2rem" @click="selectPort(3, 9)" />
      <span class="port" id="port-11" style="bottom: 28.8%; left: 55.45rem; width: 3rem; height: 2rem" @click="selectPort(3, 10)" />
      <span class="port" id="port-12" style="bottom: 28.8%; left: 59rem; width: 3rem; height: 2rem" @click="selectPort(3, 11)" />
      <span class="port" id="port-13" style="bottom: 28.8%; left: 62.6rem; width: 3rem; height: 2rem" @click="selectPort(3, 12)" />
      <span class="port" id="port-14" style="bottom: 28.8%; left: 66.15rem; width: 3rem; height: 2rem" @click="selectPort(3, 13)" />
      <span class="port" id="port-15" style="bottom: 28.8%; left: 69.7rem; width: 3rem; height: 2rem" @click="selectPort(3, 14)" />
      <span class="port" id="port-16" style="bottom: 28.8%; left: 73.3rem; width: 3rem; height: 2rem" @click="selectPort(3, 15)" />
    </vx-card>

    <movable-popup
      refVal="portConfigurationPopup"
      :title="
        'Switch ' +
        selectedPort.switch +
        ' - Port ' +
        `${selectedPort.switch === 1 ? selectedPort.port + 1 : selectedPort.port - 7}` +
        ' Configuration'
      "
      :active="selectedPort.port !== -1"
      v-on:close="selectedPort.port = -1"
      style="width: 33rem"
    >
      <template v-slot:content>
        <div class="flex flex-col gap-3">
          <div class="flex gap-3">
            <vx-card class="w-1/2 h-fit">
              <h5 class="mb-4">Status</h5>
              <div class="flex items-center justify-between mb-5">
                <p>Port</p>
                <vs-switch v-model="portValue" color="success" />
              </div>
              <div class="flex items-center justify-between">
                <p>LACP</p>
                <vs-switch v-model="lacpValue" color="success" />
              </div>
            </vx-card>

            <vx-card class="" style="width: 20rem">
              <h5 class="mb-4">Wired</h5>
              <div class="flex items-center justify-between gap-6 mb-3">
                <p>Speed</p>
                <v-select class="w-full" v-model="switchConfigurations[selectedPort.port].wired.speedValue" :options="wiredOptions" />
              </div>
              <div class="flex items-center justify-between gap-6">
                <p>Duplex</p>
                <v-select class="w-full" v-model="switchConfigurations[selectedPort.port].wired.duplexValue" :options="wiredOptions" />
              </div>
            </vx-card>
          </div>

          <vx-card class="w-full h-fit">
            <span
              class="flex items-center justify-between"
              :style="`margin-bottom: ${switchConfigurations[selectedPort.port].vlans.selections.length > 0 ? '1rem' : ''}`"
            >
              <h5>VLAN Configuration</h5>
              <vs-button size="small" type="gradient" @click="addVLAN()">Add VLAN</vs-button>
            </span>
            <div class="grid grid-cols-1 gap-3">
              <div
                v-for="(vlan, index) in switchConfigurations[selectedPort.port].vlans.selections"
                :key="index"
                class="flex flex-row justify-between items-center gap-2 bg-light p-2 main-border rounded-lg"
              >
                <span class="flex items-center gap-3 w-full">
                  <v-select class="w-1/2" v-model="vlan.name" :options="vlanOptions" />
                  <v-select class="w-1/2" v-model="vlan.tagging" :options="vlanTagOptions" />
                </span>
                <vs-button
                  size="small"
                  color="danger"
                  type="gradient"
                  class="w-fit"
                  icon="icon-x"
                  icon-pack="feather"
                  @click="removeVLAN(index)"
                />
              </div>
            </div>
          </vx-card>
        </div>
      </template>
    </movable-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      selectedPort: {
        switch: 1,
        port: -1,
      },

      wiredOptions: ['Auto', 'Half', 'Full', '100', '1000'],
      vlanOptions: ['VLAN1', 'VLAN60', 'VLAN90', 'VLAN120', 'VLAN150', 'VLAN220'],
      vlanTagOptions: ['Untagged', 'Tagged'],

      switchConfigurations: [
        // PORT 1
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: true,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN60',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN90',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN120',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN150',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN220',
                tagging: 'Tagged',
              },
            ],
          },
        },
        // PORT 2
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: true,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN60',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN90',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN120',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN150',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN220',
                tagging: 'Tagged',
              },
            ],
          },
        },
        // PORT 3
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: false,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN90',
                tagging: 'Untagged',
              },
            ],
          },
        },
        // PORT 4
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: false,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN90',
                tagging: 'Untagged',
              },
            ],
          },
        },
        // PORT 5
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: true,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN60',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN120',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN150',
                tagging: 'Tagged',
              },
            ],
          },
        },
        // PORT 6
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: true,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN60',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN120',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN150',
                tagging: 'Tagged',
              },
            ],
          },
        },
        // PORT 7
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: true,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN60',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN90',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN120',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN220',
                tagging: 'Tagged',
              },
            ],
          },
        },
        // PORT 8
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: true,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN60',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN90',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN120',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN220',
                tagging: 'Tagged',
              },
            ],
          },
        },

        // SWITCH THREE PORTS

        // PORT 1
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: true,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN60',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN90',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN120',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN220',
                tagging: 'Tagged',
              },
            ],
          },
        },
        // PORT 2
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: true,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN60',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN90',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN120',
                tagging: 'Tagged',
              },
              {
                name: 'VLAN220',
                tagging: 'Tagged',
              },
            ],
          },
        },
        // PORT 3
        {
          status: {
            portValue: false,
            portAnswer: false,
            lacpValue: false,
            lacpAnswer: false,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [],
          },
        },
        // PORT 4
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: false,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN120',
                tagging: 'Untagged',
              },
              {
                name: 'VLAN220',
                tagging: 'Tagged',
              },
            ],
          },
        },
        // PORT 5
        {
          status: {
            portValue: false,
            portAnswer: false,
            lacpValue: false,
            lacpAnswer: false,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [],
          },
        },
        // PORT 6
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: false,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN120',
                tagging: 'Untagged',
              },
            ],
          },
        },
        // PORT 7
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: false,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN60',
                tagging: 'Untagged',
              },
            ],
          },
        },
        // PORT 8
        {
          status: {
            portValue: false,
            portAnswer: true,
            lacpValue: false,
            lacpAnswer: false,
          },
          wired: {
            speedValue: null,
            speedAnswer: 'Auto',
            duplexValue: null,
            duplexAnswer: 'Auto',
          },
          vlans: {
            selections: [],
            answers: [
              {
                name: 'VLAN90',
                tagging: 'Untagged',
              },
            ],
          },
        },
      ],
    };
  },
  methods: {
    selectPort(switchNumber, portIndex) {
      this.selectedPort.switch = switchNumber;
      this.selectedPort.port = portIndex;
    },
    addVLAN() {
      this.switchConfigurations[this.selectedPort.port].vlans.selections.push({
        name: 'VLAN60',
        tagging: 'Tagged',
      });
    },
    removeVLAN(vlanIndex) {
      this.switchConfigurations[this.selectedPort.port].vlans.selections.splice(vlanIndex, 1);
    },
    markSimulation() {
      let totalScore = 0;
      console.log(this.switchConfigurations);

      this.switchConfigurations.forEach((port, index) => {
        const portElement = document.querySelector(`#port-${index + 1}`);
        let incorrect = false;

        if (port.status.portValue !== port.status.portAnswer) {
          if (portElement) portElement.style.borderColor = '#c93738';
          incorrect = true;
        }
        if (port.status.lacpValue !== port.status.lacpAnswer) {
          if (portElement) portElement.style.borderColor = '#c93738';
          incorrect = true;
        }

        if (port.wired.speedValue !== port.wired.speedAnswer) {
          if (portElement) portElement.style.borderColor = '#c93738';
          incorrect = true;
        }
        if (port.wired.duplexValue !== port.wired.duplexAnswer) {
          if (portElement) portElement.style.borderColor = '#c93738';
          incorrect = true;
        }

        if (port.vlans.selections.length !== port.vlans.answers.length) {
          if (portElement) portElement.style.borderColor = '#c93738';
          incorrect = true;
        }

        port.vlans.selections.forEach((vlan, vlanIndex) => {
          if (vlan.name !== port.vlans.answers[vlanIndex].name) {
            if (portElement) portElement.style.borderColor = '#c93738';
            incorrect = true;
          }
          if (vlan.tagging !== port.vlans.answers[vlanIndex].tagging) {
            if (portElement) portElement.style.borderColor = '#c93738';
            incorrect = true;
          }
        });

        if (incorrect === false) {
          totalScore++;
          if (portElement) portElement.style.borderColor = '#31b952';
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }
      this.$emit('simulation_getting_there', totalScore);
    },
  },
  computed: {
    portValue: {
      get() {
        return this.switchConfigurations[this.selectedPort.port].status.portValue;
      },
      set(newValue) {
        this.switchConfigurations[this.selectedPort.port].status.portValue = newValue;
      },
    },
    lacpValue: {
      get() {
        return this.switchConfigurations[this.selectedPort.port].status.lacpValue;
      },
      set(newValue) {
        this.switchConfigurations[this.selectedPort.port].status.lacpValue = newValue;
      },
    },
  },
  components: {
    vSelect,
    MovablePopup,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.port {
  position: absolute;
  border: 1px solid transparent;
  cursor: url('~@/assets/images/cursor/cursor-pointer.png'), auto;
}
</style>
